import * as Types from '../../../api';

import { gql } from '@apollo/client';
import { PhoneButtonReferencesFragmentDoc, IvrActionReferencesFragmentDoc, GatewayReferencesFragmentDoc, SecretaryReferencesFragmentDoc, OverrideCallerReferencesFragmentDoc } from '../../../utils/queries.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteExtensionMutationVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
  deleteChatHistory: Types.Scalars['Boolean']['input'];
  deleteVoicemailHistory: Types.Scalars['Boolean']['input'];
  deletePersonalAddressbook: Types.Scalars['Boolean']['input'];
  deletePresenceData: Types.Scalars['Boolean']['input'];
  relatedData: Types.ReferenceRetargetsUser;
}>;


export type DeleteExtensionMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } | null };

export type ExtensionRelatedDataQueryVariables = Types.Exact<{
  extensionId: Types.Scalars['Int']['input'];
}>;


export type ExtensionRelatedDataQuery = { __typename?: 'Query', relatedData: { __typename?: 'References', groupMemberships: Array<{ __typename?: 'Group', id: number, name: string, number?: { __typename?: 'Number', shortNumber?: string | null } | null }>, phoneButtons: Array<{ __typename?: 'BasePhoneButton', id: number, speedDialNumber?: string | null, buttonPosition: number, device?: { __typename?: 'Device', id: number, extensionId: number, extension?: { __typename?: 'User', displayName: string, numberId: number, number?: { __typename?: 'Number', shortNumber?: string | null } | null } | null } | null }>, ivrActions: Array<{ __typename?: 'IvrAction', id: number, button: number, ivrProfile?: { __typename?: 'IvrProfile', name: string, ivr?: { __typename?: 'Ivr', id: number, name: string, numberId: number } | null, mainParent?: { __typename?: 'IvrProfile', ivr?: { __typename?: 'Ivr', id: number, name: string, numberId: number } | null } | null } | null, targetNumber1?: { __typename?: 'Number', shortNumber?: string | null } | null }>, gateways: Array<{ __typename?: 'Gateway', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null }>, secretary: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null }>, overrideCaller: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null }> } };

export type GetExtensionsQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type GetExtensionsQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, faxes?: { __typename?: 'FaxList', items: Array<{ __typename?: 'Fax', id: number, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', id: number, name: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, ivrs?: { __typename?: 'IvrList', items: Array<{ __typename?: 'Ivr', name: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, gateways?: { __typename?: 'GatewayList', items: Array<{ __typename?: 'Gateway', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null };


export const DeleteExtensionDocument = gql`
    mutation DeleteExtension($userId: Int!, $deleteChatHistory: Boolean!, $deleteVoicemailHistory: Boolean!, $deletePersonalAddressbook: Boolean!, $deletePresenceData: Boolean!, $relatedData: ReferenceRetargetsUser!) {
  deleteUser(
    userId: $userId
    deleteChatHistory: $deleteChatHistory
    deleteVoicemailHistory: $deleteVoicemailHistory
    deletePersonalAddressbook: $deletePersonalAddressbook
    deletePresenceData: $deletePresenceData
    relatedData: $relatedData
  ) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type DeleteExtensionMutationFn = Apollo.MutationFunction<DeleteExtensionMutation, DeleteExtensionMutationVariables>;

/**
 * __useDeleteExtensionMutation__
 *
 * To run a mutation, you first call `useDeleteExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExtensionMutation, { data, loading, error }] = useDeleteExtensionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      deleteChatHistory: // value for 'deleteChatHistory'
 *      deleteVoicemailHistory: // value for 'deleteVoicemailHistory'
 *      deletePersonalAddressbook: // value for 'deletePersonalAddressbook'
 *      deletePresenceData: // value for 'deletePresenceData'
 *      relatedData: // value for 'relatedData'
 *   },
 * });
 */
export function useDeleteExtensionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExtensionMutation, DeleteExtensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExtensionMutation, DeleteExtensionMutationVariables>(DeleteExtensionDocument, options);
      }
export type DeleteExtensionMutationHookResult = ReturnType<typeof useDeleteExtensionMutation>;
export type DeleteExtensionMutationResult = Apollo.MutationResult<DeleteExtensionMutation>;
export type DeleteExtensionMutationOptions = Apollo.BaseMutationOptions<DeleteExtensionMutation, DeleteExtensionMutationVariables>;
export const ExtensionRelatedDataDocument = gql`
    query ExtensionRelatedData($extensionId: Int!) {
  relatedData(id: $extensionId, numberType: EXTENSION) {
    groupMemberships {
      id
      name
      number {
        shortNumber
      }
    }
    ...PhoneButtonReferences
    ...IvrActionReferences
    ...GatewayReferences
    ...SecretaryReferences
    ...OverrideCallerReferences
  }
}
    ${PhoneButtonReferencesFragmentDoc}
${IvrActionReferencesFragmentDoc}
${GatewayReferencesFragmentDoc}
${SecretaryReferencesFragmentDoc}
${OverrideCallerReferencesFragmentDoc}`;

/**
 * __useExtensionRelatedDataQuery__
 *
 * To run a query within a React component, call `useExtensionRelatedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionRelatedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionRelatedDataQuery({
 *   variables: {
 *      extensionId: // value for 'extensionId'
 *   },
 * });
 */
export function useExtensionRelatedDataQuery(baseOptions: Apollo.QueryHookOptions<ExtensionRelatedDataQuery, ExtensionRelatedDataQueryVariables> & ({ variables: ExtensionRelatedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionRelatedDataQuery, ExtensionRelatedDataQueryVariables>(ExtensionRelatedDataDocument, options);
      }
export function useExtensionRelatedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionRelatedDataQuery, ExtensionRelatedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionRelatedDataQuery, ExtensionRelatedDataQueryVariables>(ExtensionRelatedDataDocument, options);
        }
export function useExtensionRelatedDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionRelatedDataQuery, ExtensionRelatedDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionRelatedDataQuery, ExtensionRelatedDataQueryVariables>(ExtensionRelatedDataDocument, options);
        }
export type ExtensionRelatedDataQueryHookResult = ReturnType<typeof useExtensionRelatedDataQuery>;
export type ExtensionRelatedDataLazyQueryHookResult = ReturnType<typeof useExtensionRelatedDataLazyQuery>;
export type ExtensionRelatedDataSuspenseQueryHookResult = ReturnType<typeof useExtensionRelatedDataSuspenseQuery>;
export type ExtensionRelatedDataQueryResult = Apollo.QueryResult<ExtensionRelatedDataQuery, ExtensionRelatedDataQueryVariables>;
export const GetExtensionsDocument = gql`
    query GetExtensions($domainId: Int!) {
  users(domainId: $domainId) {
    items {
      id
      number {
        id
        shortNumber
      }
      displayName
    }
  }
  faxes(domainId: $domainId) {
    items {
      id
      number {
        id
        shortNumber
      }
    }
  }
  groups(domainId: $domainId) {
    items {
      id
      name
      number {
        id
        shortNumber
      }
    }
  }
  ivrs(domainId: $domainId) {
    items {
      name
      number {
        id
        shortNumber
      }
    }
  }
  gateways(domainId: $domainId) {
    items {
      id
      displayName
      number {
        id
        shortNumber
      }
    }
  }
}
    `;

/**
 * __useGetExtensionsQuery__
 *
 * To run a query within a React component, call `useGetExtensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtensionsQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useGetExtensionsQuery(baseOptions: Apollo.QueryHookOptions<GetExtensionsQuery, GetExtensionsQueryVariables> & ({ variables: GetExtensionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExtensionsQuery, GetExtensionsQueryVariables>(GetExtensionsDocument, options);
      }
export function useGetExtensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExtensionsQuery, GetExtensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExtensionsQuery, GetExtensionsQueryVariables>(GetExtensionsDocument, options);
        }
export function useGetExtensionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExtensionsQuery, GetExtensionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExtensionsQuery, GetExtensionsQueryVariables>(GetExtensionsDocument, options);
        }
export type GetExtensionsQueryHookResult = ReturnType<typeof useGetExtensionsQuery>;
export type GetExtensionsLazyQueryHookResult = ReturnType<typeof useGetExtensionsLazyQuery>;
export type GetExtensionsSuspenseQueryHookResult = ReturnType<typeof useGetExtensionsSuspenseQuery>;
export type GetExtensionsQueryResult = Apollo.QueryResult<GetExtensionsQuery, GetExtensionsQueryVariables>;